<div class="flex flex-col min-h-screen">
  <div class="relative z-[5]">
    <ticketing-header />
  </div>

  <router-outlet></router-outlet>

  <div class="flex-grow"></div>

  <div class="relative -z-10 bg-gray-800 pb-[6.5rem] pt-12 flex place-content-center">
    <div class="text-center text-gray-300 text-xs font-light mx-2">
      Copyright © {{ currentYear() }} - Die Fachschaften Elektrotechnik, Maschinenbau und Medizin der RWTH Aachen
    </div>
  </div>
</div>

<div class="lg:hidden">
  <ticketing-mobile-menu [isOpen]="mobileMenuOpen()" />

  <ticketing-hamburger-overlay
    class="fixed z-20 inset-x-0 bottom-5"
    [menuState]="mobileMenuOpen()"
    (buttonClick)="this.mobileMenuOpen.set(!this.mobileMenuOpen())"
  />
</div>
